import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CardActions,
  TablePagination,
} from '@material-ui/core'
import EditBtn from 'components/EditBtn'
import { NumToCourseType } from 'common/enum'
import { boolStr, send } from 'helpers/utils'

const WorkoutCategory = (props) => {
  const { data, page, onPageChange } = props

  return (
    <Card>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Content ID</TableCell>
                  <TableCell>Course Name</TableCell>
                  <TableCell>Course Type</TableCell>
                  <TableCell>Week</TableCell>
                  <TableCell>Sequence</TableCell>
                  <TableCell>Subtitle</TableCell>
                  <TableCell>Active</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {((data && data.rows) || []).map(record => (
                    <TableRow key={record.id} hover>
                      <TableCell>{record.content_id}</TableCell>
                      <TableCell>{record.course && record.course.name}</TableCell>
                      <TableCell>{record.course && send(NumToCourseType, record.course.type, 'value')}</TableCell>
                      <TableCell>{record.week}</TableCell>
                      <TableCell>{record.sequence}</TableCell>
                      <TableCell>{record.subtitle}</TableCell>
                      <TableCell>{boolStr(record.active)}</TableCell>
                      <TableCell>
                        <EditBtn path={`/course-videos/${record.id}/edit`} {...props} />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={'flex-right'}>
        <TablePagination
          component="div"
          count={data.count || 0}
          onChangePage={onPageChange}
          page={page - 1}
          rowsPerPage={10}
          rowsPerPageOptions={[10]}
        />
      </CardActions>
    </Card>
  )
}

export default WorkoutCategory
